export class VerifyBankRequest {
  amount1: number;
  amount2: number;
}
